import React from 'react';
import { Edit2, Trash2 } from 'lucide-react';

const SelectedItemsList = ({ items, onEdit, onRemove }) => {
  if (!items || items.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>לא נבחרו פריטים</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-gray-50 border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <span className="font-semibold text-brown-800">
                  {item.name}
                </span>
                {item.isCustom && (
                  <span className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full">
                    מותאם
                  </span>
                )}
              </div>
              
              {item.quantity > 1 && (
                <p className="text-sm text-brown-600 mb-2">
                  כמות: {item.quantity}
                </p>
              )}

              {item.tags && item.tags.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {item.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="flex items-center gap-2 mr-4">
              <button
                onClick={() => onEdit(item, index)}
                className="p-2 text-orange-600 hover:bg-orange-50 rounded-lg transition-colors"
                aria-label="ערוך פריט"
                type="button"
              >
                <Edit2 className="h-4 w-4" />
              </button>
              <button
                onClick={() => onRemove(index)}
                className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                aria-label="מחק פריט"
                type="button"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SelectedItemsList;

